import React from "react";
import Icon from "./Icon";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

// FSA cleaning standards reference card — detergent/disinfectant/sanitiser,
// BS EN standards, dilution & contact time. Shown on the cleaning screens.
const ROWS = [
  { term: "Detergent", body: "Removes grease, food residue and visible dirt. It does NOT kill bacteria — always clean with a detergent first." },
  { term: "Disinfectant", body: "Reduces bacteria to a safe level. Use AFTER a detergent, on a visibly clean surface." },
  { term: "Sanitiser", body: "A 2-in-1 product that both cleans and disinfects — apply twice (clean, then again to disinfect)." },
];

export default function CleaningReferenceModal({ open, onClose }) {
  const { t: tr } = useI18n();
  if (!open) return null;
  return (
    <div className="modal-backdrop modal-center" style={{ zIndex: 9000 }} onClick={onClose}>
      <div data-testid="cleaning-reference-modal" onClick={(e) => e.stopPropagation()} style={{ background: C.card, borderRadius: R.lg, padding: S.xl, width: "100%", maxWidth: 460, border: `1px solid ${C.borderStrong}`, maxHeight: "88vh", overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: S.sm, marginBottom: S.md }}>
          <Icon name="sparkles" size={22} color="#06b6d4" />
          <div className="display" style={{ color: C.text, fontSize: 20, fontWeight: 900, flex: 1 }}>{tr("cleaning.refTitle")}</div>
          <button data-testid="cleaning-reference-close" className="pressable" onClick={onClose} style={{ background: "transparent", border: "none", color: C.muted, fontSize: 26, fontWeight: 900, lineHeight: 1 }}>×</button>
        </div>

        <div style={{ color: C.sub, fontSize: 13, fontWeight: 800, textTransform: "uppercase", marginBottom: S.sm }}>{tr("cleaning.refKnowDiff")}</div>
        {ROWS.map((r) => (
          <div key={r.term} style={{ background: C.card2, borderRadius: R.md, padding: S.md, marginBottom: S.sm, border: `1px solid ${C.border}` }}>
            <div style={{ color: C.amber, fontWeight: 900, fontSize: 15 }}>{r.term}</div>
            <div style={{ color: C.text, fontSize: 13.5, marginTop: 4, lineHeight: 1.45 }}>{r.body}</div>
          </div>
        ))}

        <div style={{ color: C.sub, fontSize: 13, fontWeight: 800, textTransform: "uppercase", margin: `${S.md}px 0 ${S.sm}px` }}>{tr("cleaning.refStandards")}</div>
        <div style={{ background: C.card2, borderRadius: R.md, padding: S.md, marginBottom: S.sm, border: `1px solid ${C.border}`, color: C.text, fontSize: 13.5, lineHeight: 1.5 }}>
          Use a disinfectant / sanitiser that meets <b>BS EN 1276</b> or <b>BS EN 13697</b>. These confirm the product actually kills food-poisoning bacteria to a food-safe level.
        </div>

        <div style={{ color: C.sub, fontSize: 13, fontWeight: 800, textTransform: "uppercase", margin: `${S.md}px 0 ${S.sm}px` }}>{tr("cleaning.refDilution")}</div>
        <div style={{ background: "rgba(6,182,212,0.12)", borderRadius: R.md, padding: S.md, border: `1px solid #06b6d4`, color: C.text, fontSize: 13.5, lineHeight: 1.5 }}>
          Always follow the manufacturer's <b>dilution rate</b>. After applying, leave the product on the surface for the full <b>contact time</b> (commonly 30 seconds – 5 minutes) before wiping or rinsing — wiping too soon means bacteria survive.
        </div>
      </div>
    </div>
  );
}
